export default __webpack_public_path__ + "static/media/sponsor_dazzle.77bc939d.png";